import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type QuizRewardFlyPending = {
  quizPathIndex?: number;
  quizId?: string;
};

type QuizRewardFlyState = {
  pending: QuizRewardFlyPending | null;
};

const initialState: QuizRewardFlyState = {
  pending: null,
};

const quizRewardFlySlice = createSlice({
  name: "quizRewardFly",
  initialState,
  reducers: {
    setPendingQuizRewardFly: (
      state,
      action: PayloadAction<QuizRewardFlyPending>,
    ) => {
      state.pending = action.payload;
    },
    clearQuizRewardFly: (state) => {
      state.pending = null;
    },
  },
});

export const { setPendingQuizRewardFly, clearQuizRewardFly } =
  quizRewardFlySlice.actions;

export default quizRewardFlySlice.reducer;
